import { DestinationItemType } from '@tableau/nested-project-explorer';

import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { CommonErrorCode, PredictiveModelErrorCode, QuotaErrorCode} from '~commonInfra/utils/ErrorCodes';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { L10n } from '../../commonInfra/L10n/L10n';
import { IPredictiveModelBase } from '../models/IPredictiveModelInfo';

export class PredictiveModelErrors {
  public static errorDetailsFor(PredictiveModelErrorItem: IErrorItem<IPredictiveModelBase>): IErrorDetail {
    return {
      itemName: PredictiveModelErrorItem.item.name,
      itemUrl:
      PredictiveModelErrorItem.error.code === PredictiveModelErrorCode.PredictiveModelNotFound
      ? null
      : PredictiveModelErrors.predictiveModelUrl(PredictiveModelErrorItem.item),
      errorMessage: PredictiveModelErrors.errorMessageFor(PredictiveModelErrorItem)
    };
  }

  static errorMessageFor(errorItem: IErrorItem<IPredictiveModelBase>) {
    const predictiveModel = errorItem.item;
    const errorCode = errorItem.error.code;

    switch (errorCode) {
      case PredictiveModelErrorCode.PredictiveModelNotFound:
        return Messages.errorPredictiveModelNotFound({ PREDICTIVE_MODEL_NAME: L10n.elideIfLong(predictiveModel.name)});
      case PredictiveModelErrorCode.PredictiveModelWithSameNameInDestinationContainer:
        return Messages.errorPredictiveModelNameAlreadyExistsInDestinationProject();
      case PredictiveModelErrorCode.PredictiveModelVersionDeployedOrTraining:
        return Messages.errorPredictiveModelVersionDeployedOrTraining();
      default:
        return Messages.errorUnknown();
    }
  }

  public static moveContentToContainerErrorMessageDetailsFor(predictiveModelErrorItem: IErrorItem<IPredictiveModelBase>, destinationType: DestinationItemType): IErrorDetail {
    return {
      itemName: predictiveModelErrorItem.item.name,
      itemUrl:
      predictiveModelErrorItem.error.code === PredictiveModelErrorCode.PredictiveModelNotFound
          ? null
          : PredictiveModelErrors.predictiveModelUrl(predictiveModelErrorItem.item),
      errorMessage: PredictiveModelErrors.moveContentToContainerErrorMessageFor(predictiveModelErrorItem, destinationType)
    };
  }

  static moveContentToContainerErrorMessageFor(errorItem: IErrorItem<IPredictiveModelBase>, destinationType: DestinationItemType) {
    const predictiveModel = errorItem.item;
    const errorCode = errorItem.error.code;

    switch (errorCode) {
      case PredictiveModelErrorCode.PredictiveModelNotFound:
        return Messages.errorPredictiveModelNotFound({ PREDICTIVE_MODEL_NAME: L10n.elideIfLong(predictiveModel.name)});
      case PredictiveModelErrorCode.PredictiveModelWithSameNameInDestinationContainer:
        const errorMessage = destinationType === DestinationItemType.personalSpace ?
        Messages.errorPredictiveModelNameAlreadyExistsInPersonalSpace():
        Messages.errorPredictiveModelNameAlreadyExistsInDestinationProject();
        return errorMessage;
      case CommonErrorCode.MoveInsufficientPermissionsOnContent:
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorPredictiveModelMoveInsufficientPermissions();
      case QuotaErrorCode.CONTAINER_STORAGE_QUOTA_LIMIT_EXCEEDED:
        return Messages.personalSpaceStorageQuotaError();
      default:
        return Messages.errorUnknown();
    }
  }

  static predictiveModelUrl(predictiveModel: IPredictiveModelBase): string {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls ? siteUrls.predictiveModelUrl(predictiveModel.id) : '';
  }
}
